"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _eventConstants = _interopRequireDefault(require("../../../../constants/eventConstants"));
var _Button = require("../../../../elements/button/Button");
var _Input = _interopRequireDefault(require("../../../../elements/input/Input"));
var _base64utils = require("../../../../utils/base64utils/base64utils");
var _env = _interopRequireDefault(require("../../../../utils/env/env"));
var _Message = require("../../../message/Message");
var _EmailMeSuccess = _interopRequireDefault(require("../email-me-success/EmailMeSuccess"));
var _emailMeModule = _interopRequireDefault(require("./../email-me/email-me.module.scss"));
var _emailMeFormModule = _interopRequireDefault(require("./email-me-form.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  fields: {},
  submitting: false,
  showErrorMessage: false,
  submitted: false,
  touched: false
};
var EMAIL_CLAIM_STRING = 'https://www.johnlewis.com/auth/email';
var EmailMeForm = /*#__PURE__*/function (_Component) {
  function EmailMeForm() {
    var _this;
    _classCallCheck(this, EmailMeForm);
    _this = _callSuper(this, EmailMeForm);
    // stores the fields' validation configuration outside of state
    _defineProperty(_this, "validationConfig", {});
    _this.state = initialState;
    _this.onFieldChange = _this.onFieldChange.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    return _this;
  }
  _inherits(EmailMeForm, _Component);
  return _createClass(EmailMeForm, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.setFormFields();
              this.setTouchedState();
              _context.n = 1;
              return this.setDefaultEmailAddress();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "onFieldChange",
    value: function onFieldChange(id, value) {
      var _this$state = this.state,
        fields = _this$state.fields,
        submitted = _this$state.submitted;
      this.setState({
        touched: true
      });
      fields[id].value = value;

      // only validate on field change when form has already been submitted
      if (submitted) {
        fields[id].error = this.validate(id, value);
      }
      this.setState({
        fields: fields,
        showErrorMessage: false
      });
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      var _this2 = this;
      e.preventDefault();
      var _this$props = this.props,
        onSubmit = _this$props.onSubmit,
        shouldSelectSize = _this$props.shouldSelectSize;
      var _this$state2 = this.state,
        fields = _this$state2.fields,
        touched = _this$state2.touched;
      var formData = {};
      var valid = true;
      Object.keys(fields).forEach(function (id) {
        var field = fields[id];
        field.error = _this2.validate(id, field.value);
        // use name rather than id because the form uses the name to identify the field
        formData[field.name] = field.value;
        if (field.error || !touched || field.value === '') {
          valid = false;
        }
        if (shouldSelectSize) {
          var event = new CustomEvent(_eventConstants.default.SKU_NOT_SELECTED_EVENT);
          window.dispatchEvent(event);
          valid = false;
        }
        _this2.setState({
          fields: fields,
          showErrorMessage: !valid
        });
        if (valid) {
          if (typeof onSubmit === 'function') {
            _this2.setState({
              submitting: true
            });
            onSubmit(formData).then(function () {
              _this2.setState({
                submitting: false,
                submitted: true
              });
            }).catch(function () {
              _this2.setState({
                submitting: false,
                submitted: false
              });
            });
          }
        }
      });
    }
  }, {
    key: "setTouchedState",
    value: function setTouchedState() {
      this.setState({
        touched: false
      });
    }
  }, {
    key: "setDefaultEmailAddress",
    value: function () {
      var _setDefaultEmailAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _window$auth, jwtToken, jwtPayload, decodedPayload, emailAddress;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!_env.default.isClient) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return (_window$auth = window.auth0) === null || _window$auth === void 0 ? void 0 : _window$auth.getTokenIfAuthenticated();
            case 1:
              jwtToken = _context2.v;
              if (jwtToken) {
                try {
                  jwtPayload = jwtToken.split('.')[1] || '';
                  decodedPayload = JSON.parse((0, _base64utils.decode)(jwtPayload)) || {};
                  emailAddress = decodedPayload[EMAIL_CLAIM_STRING];
                  this.setState({
                    emailAddress: emailAddress
                  });
                  this.onFieldChange('email', emailAddress);
                } catch (error) {
                  // Do nothing; this is just to ensure that no error is thrown
                }
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function setDefaultEmailAddress() {
        return _setDefaultEmailAddress.apply(this, arguments);
      }
      return setDefaultEmailAddress;
    }()
  }, {
    key: "setFormFields",
    value: function setFormFields() {
      var _this3 = this;
      var fields = this.props.fields;
      fields.forEach(function (field) {
        // initialise the field state
        fields[field.id] = {
          id: field.id,
          name: field.name,
          label: field.label,
          value: field.value,
          error: '',
          normalize: field.normalize,
          required: field.required,
          regex: field.regex,
          maxLength: field.maxLength,
          errors: field.validationMessageKeys
        };

        // initialise the field validation
        _this3.validationConfig[field.id] = {
          required: field.required,
          regex: field.regex,
          maxLength: field.maxLength,
          errors: field.validationMessageKeys
        };
      });

      // Get rid of the random first item in the array
      fields.shift();
      this.setState({
        fields: fields
      });
    }
  }, {
    key: "getErrorTitle",
    value: function getErrorTitle() {
      return "We're sorry, but something's not working right now, please try again later";
    }
  }, {
    key: "validate",
    value: function validate(id, value) {
      var _this$validationConfi = this.validationConfig[id],
        required = _this$validationConfi.required,
        regex = _this$validationConfi.regex,
        maxLength = _this$validationConfi.maxLength,
        errors = _this$validationConfi.errors;
      var error = '';
      if (required && value === '') {
        error = errors.required;
      } else if (value && maxLength && value.length > maxLength) {
        error = errors.maxLength;
      } else if (value && regex && !value.match(regex)) {
        error = errors.regex;
      }
      return error;
    }
  }, {
    key: "countErrors",
    value: function countErrors() {
      var errors = 0;
      var fields = this.state.fields;

      // TODO find a better way of doing this
      Object.keys(fields).forEach(function (id) {
        var field = fields[id];
        if (field.error) {
          errors += 1;
        }
      });
      return errors;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var errors = this.countErrors();
      var _this$state3 = this.state,
        showErrorMessage = _this$state3.showErrorMessage,
        skuId = _this$state3.skuId,
        submitting = _this$state3.submitting,
        submitted = _this$state3.submitted,
        _this$state3$emailAdd = _this$state3.emailAddress,
        emailAddress = _this$state3$emailAdd === void 0 ? '' : _this$state3$emailAdd;
      var _this$props2 = this.props,
        showNetworkError = _this$props2.showNetworkError,
        formId = _this$props2.formId,
        submitButton = _this$props2.submitButton,
        modalClose = _this$props2.modalClose,
        shouldSelectSize = _this$props2.shouldSelectSize,
        _this$props2$customer = _this$props2.customerNotifiableEvents,
        hasBackInStockEmails = _this$props2$customer.backInStock,
        hasOnPreorderLaunchEmails = _this$props2$customer.onPreorderLaunch,
        hasStreetDateMessage = _this$props2.hasStreetDateMessage,
        shouldShowContinueShoppingCTA = _this$props2.shouldShowContinueShoppingCTA;
      var terms = hasBackInStockEmails && !hasStreetDateMessage ? "We'll also share some similar product recommendations. If the item does not come back in stock we will notify you." : undefined;
      var displayText = hasOnPreorderLaunchEmails ? 'Email me when available to pre-order' : 'Email me when available';
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _emailMeFormModule.default.formBorder,
        "data-testid": "component-email-me-form",
        children: [showNetworkError && !shouldSelectSize && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Message.Message, {
          title: this.getErrorTitle(),
          type: "error"
        }), (!submitted || showNetworkError) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [hasBackInStockEmails && /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            className: (0, _classnames.default)(_emailMeModule.default.heading, _emailMeModule.default['heading--center']),
            children: "Out of stock online"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
            className: _emailMeFormModule.default['c-form'],
            id: formId,
            noValidate: true,
            onSubmit: this.onSubmit,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
              className: (0, _classnames.default)(_emailMeModule.default.label, _defineProperty({}, _emailMeModule.default['label--no-heading'], !hasBackInStockEmails)),
              htmlFor: "email",
              children: displayText
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.default, {
              className: (0, _classnames.default)(_emailMeFormModule.default.input, _defineProperty({}, _emailMeFormModule.default['input--error'], showErrorMessage)),
              defaultValue: emailAddress,
              id: "email",
              name: "email",
              onChange: function onChange(e) {
                _this4.onFieldChange('email', e.target.value);
              },
              required: true,
              type: "email"
            }), showErrorMessage && errors > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: _emailMeFormModule.default.formError,
              "data-testid": "email-me-error-message",
              children: "Please enter a valid email address"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.PrimaryButton, {
              disabled: showErrorMessage,
              submitting: submitting,
              type: "submit",
              children: submitButton
            })]
          }), terms && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: _emailMeFormModule.default.terms,
            children: terms
          })]
        }), submitted && !showNetworkError && /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmailMeSuccess.default, {
          modalClose: modalClose,
          shouldShowContinueShoppingCTA: shouldShowContinueShoppingCTA
        })]
      }, skuId);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var _props$fields = props.fields,
        fields = _props$fields === void 0 ? [] : _props$fields;
      var emailField = fields[0] || {};

      // reset form if user switches between 2 skus that are out of stock

      if (props.skuId !== state.skuId && !props.shouldSelectSize) {
        return _objectSpread(_objectSpread({}, initialState), {}, {
          skuId: props.skuId,
          touched: !!state.emailAddress,
          fields: _defineProperty({}, emailField.id, _objectSpread(_objectSpread({}, emailField), {}, {
            value: state.emailAddress,
            error: ''
          }))
        });
      }
      return null;
    }
  }]);
}(_react.Component);
EmailMeForm.defaultProps = {
  fields: [],
  onSubmit: function onSubmit() {},
  submitButton: 'Submit',
  formId: "email-me-form",
  showNetworkError: false,
  shouldSelectSize: false,
  customerNotifiableEvents: {
    backInStock: false,
    onPreorderLaunch: false
  },
  hasStreetDateMessage: false
};
EmailMeForm.propTypes = {
  fields: _propTypes.default.arrayOf(_propTypes.default.shape()),
  onSubmit: _propTypes.default.func,
  submitButton: _propTypes.default.string,
  formId: _propTypes.default.string,
  showNetworkError: _propTypes.default.bool,
  shouldSelectSize: _propTypes.default.bool,
  customerNotifiableEvents: _propTypes.default.shape({
    backInStock: _propTypes.default.bool,
    onPreorderLaunch: _propTypes.default.bool
  }),
  hasStreetDateMessage: _propTypes.default.bool,
  showContinueShoppingCTA: _propTypes.default.bool
};
var _default = exports.default = EmailMeForm;